var loginPasswordMixin = {

}
// 验证密码
 loginPasswordMixin.password = {
	data(){
		return {

		}
	},
	methods:{


		//校验密码规则
		vaildPasswordRule(password){
			let obj = {
				bool:false,
				tips:'',
			}
			password = password || '';
			if(!password){
				return obj
			}

			
			// 校验输入字符是否合法 : 密码只能包含数字、字母和特殊字符
			const passwordRegex1 = /^[a-zA-Z0-9!@#$%^&*]+$/;
			// 校验长度:	长度8-22位
			const passwordRegex2 = /^[a-zA-Z0-9!@#$%^&*]{8,22}$/;
			// 校验至少包含一个大写字母:   必须包含大写字母
			const passwordRegex3 = /^(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,22}$/;
			// 校验至少包含一个小写字母 :  必须包含小写字母
			const passwordRegex4 = /^(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9!@#$%^&*]{8,22}$/;
			// 必须包含至少一个特殊字符 !@#$%^&*  :      必须包含至少一个特殊字符 !@#$%^&*
			const passwordRegex5 = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,22}$/;

			if(!passwordRegex1.test(password)){
				obj.bool = true;
				obj.tips = '密码要求：只能包含数字、字母和特殊字符';
				return obj
			}
			if(!passwordRegex2.test(password)){
				obj.bool = true;
				obj.tips = '密码要求：长度8-22位';
				return obj
			}
			if(!passwordRegex3.test(password)){
				obj.bool = true;
				obj.tips = '密码要求：必须包含大写字母';
				return obj
			}
			if(!passwordRegex4.test(password)){
				obj.bool = true;
				obj.tips = '密码要求：必须包含小写字母';
				return obj
			}
			if(!passwordRegex5.test(password)){
				obj.bool = true;
				obj.tips = '密码要求：必须包含至少一个特殊字符 !@#$%^&*';
				return obj
			}
			
			return obj
		},



	
	}

}


export default loginPasswordMixin